import createReactClass from 'create-react-class';
// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import uniqBy from 'lodash.uniqby';
// Import class
import genericHelpers from '../_utils/generic-helpers';
import { builderDispatch, WebUI } from '../_utils/ui';
import DeliveryCalculator from '../_utils/_delivery-options/calculator';
import OrderCalculator from '../_utils/_order-data/order-calculator';
import OrderContents from '../_utils/_order-data/order-contents';
import translate from '../_utils/tools/translate';
import { isPostalCodeLocal } from '../_utils/validations';
import CartItemsChangeEvents from './cart-items-change-events';
import DeletionFirmness from './deletion-firmness';
import Pluralizer from './pluralizer';
import LocationCookies from '../_libs/location-cookies';
import ZipCodes from '../_libs/zip-codes';
import 'Utils/extensions/set/first-and-last';
import { checkoutBlockers } from './checkout-blockers';
import {
  orderTimestampsPresent,
  unavailableOrderItems,
} from './order-timestamps';
import { pickupStoreWithEverythingInStock } from './alternate-stores';
import { updateOnServer, deleteOnServer } from './server-actions';

// Import JSX Modules
import EmptyCart from './empty-cart';
import Prints from './prints';
import Prism from './prism';
import Totalizer from './totalizer';
import DeliveryOptionsGroupHeader from './delivery-options-group-header';
import DeliveryOptionAdjustments from './delivery-option-adjustments';
import Modal from '../_utils/modal';
import DisperateDeliveryOptionsModal from './disperate-delivery-options-modal';
import IncompleteWmbAccountMessage from './walmart-business/incomplete_wmb_account_message';
import { AlbumsMessage } from './totalizer/albums-message';
import TaxesAndDeliveryPrompt from './taxes-and-delivery-prompt';
import WalmartPlusPromotion from './walmart_plus_promotion';
import { getPromotionMessageKey } from './walmart_plus_promotion/get-promotion-message-key';
import DeliveryOptionsForm from '../_utils/_delivery-options/delivery-options-form';
import { Card } from './card';
import { PICKUP_DELIVERY_OPTION_TYPES } from '../../constants/delivery-option-types';

// Self-contained module for populating WM store preference cookie
import '../_application/walmart-preferences';

// -----------------------------------------------------------
//  Cart
// -----------------------------------------------------------
const Cart = createReactClass({
  displayName: 'Cart',

  getInitialState() {
    const {
      order: { prints_summary: prints, prism_items: prismItems },
    } = { ...this.props };

    const location = (({
      pickup_location: pickupLocation,
      collection_location: collectionLocation,
    }) => {
      const deliveryOptionMap = OrderContents.groupedByDeliveryOptionType({
        prints,
        prismItems,
      });

      if (pickupLocation && deliveryOptionMap.has('PICKUP')) {
        return pickupLocation;
      }

      if (collectionLocation && deliveryOptionMap.has('COLLECT')) {
        return collectionLocation;
      }
    })(this.props.order);

    const zipCode =
      ZipCodes.load() ||
      ((location = {}) => {
        // if we can't find a zip code then fallback to one from the collectionLocation,
        // which could be the Order, Fulfiller or Walmart Store but they do not follow consistent interface
        return (
          location?.postcode ??
          get(location, 'address.postcode') ??
          get(location, 'address.zip_code')
        );
      })(location);

    return {
      prints: {
        ...prints,
        deletedFinishes: [],
      },
      prismItems,
      zipCode,
      popoverOpen: !zipCode,
      searching: false,
      locations: {
        pickup: [],
        collection: [],
        selected: location?.id,
      },
      alternatePickupStore: null,
      updating: {}, // e.g. prints: true; 12345: true, all: true
      loggedIn: typeof App !== 'undefined' && App.order.logged_in(),
      crossSellItemReminderShow: false,
    };
  },

  UNSAFE_componentWillMount() {
    this.builderDispatchToken = builderDispatch.register((payload) => {
      switch (payload.type) {
        case CartItemsChangeEvents.REMOVE_PRINT:
          this.handlePrintsDeleteSize(payload.size);
          break;

        case CartItemsChangeEvents.REMOVE_PRINTS:
          this.handlePrintsDeleteAll(payload.finish);
          break;

        case CartItemsChangeEvents.UNREMOVE_PRINT:
          this.handlePrintsUndeleteSize(payload.size);
          break;

        case CartItemsChangeEvents.UNREMOVE_PRINTS:
          this.handlePrintsUndeleteAll(payload.finish);
          break;

        case CartItemsChangeEvents.REMOVE_PRISM:
          this.handlePrismItemDelete(payload.item, payload.soft);
          break;

        case CartItemsChangeEvents.UNREMOVE_PRISM:
          this.handlePrismItemUndelete(payload.item);
          break;

        case CartItemsChangeEvents.QUANTITY_CHANGE:
          this.handlePrismItemQuantityChange(payload.item, payload.value);
          break;

        case CartItemsChangeEvents.DELIVERY_OPTION_CHANGE:
          this.handleDeliveryOptionChange(payload.itemId, payload.optionId);
          break;

        case CartItemsChangeEvents.ZIP_CODE_CHANGE:
          this.handleZipCodeChange(payload.value);
          break;

        case CartItemsChangeEvents.PICKUP_LOCATION_CHANGE:
          this.handleSelectedLocationChange(payload.value);
          break;

        case WebUI.LOGIN:
          this.handleLoggedIn();
          this.handleWalmartBusinessOrgLoginMessage(
            payload.wmb_user_account_incomplete,
          );
          break;

        case WebUI.CART_MERGED:
          this.handleCartMerged(payload.basketPath);
          break;
      }
    });

    this.setState({
      itemsLimitModelIsOpen: this.itemsLimitExceeded(),
      disperateDeliveryOptionsModalIsOpen:
        this.isDeliveryMethodScopeOrder() &&
        OrderContents.hasMultipleSelectedDeliveryOptions(this.state),
    });
  },

  componentDidMount() {
    const {
      urls: { geolocation_to_zipcode: geolocationToZipcodeUrl },
      order: { default_pickup_location: defaultPickupLocation },
      buying_restrictions,
    } = this.props;
    let zipCodeFound = false;

    if (typeof window !== 'undefined' && window.localStorage) {
      const storedStoreId = window.localStorage.getItem('storeId');
      const currentStoreId = this.state.locations.selected;

      if (storedStoreId && String(currentStoreId) !== String(storedStoreId)) {
        this.handleSelectedLocationChange(storedStoreId);
      }
    }

    (() => {
      const { zipCode } = this.state;
      if (zipCode) {
        zipCodeFound = true;
        this.handleZipCodeChange(zipCode);
        return;
      }
      if (geolocationToZipcodeUrl && 'geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          ({ coords: { latitude, longitude } }) => {
            ZipCodes.fromLatLong(
              geolocationToZipcodeUrl,
              latitude,
              longitude,
              ({ zipcode: zipCode }) => {
                zipCodeFound = true;
                this.handleZipCodeChange(zipCode);
              },
            );
          },
        );
      }
    })();

    if (
      !zipCodeFound &&
      this.hasPickupDeliveryOptionType() &&
      defaultPickupLocation
    ) {
      this.updateDefaultStoreSelection(defaultPickupLocation);
      this.hidePopover();
    }

    this.notifyCartItemsChanged(CartItemsChangeEvents.LOADED);
    this.handleWalmartBusinessOrgLoginMessage(
      buying_restrictions?.display_login_org_message,
    );
  },

  componentWillUnmount() {
    builderDispatch.unregister(this.builderDispatchToken);
  },

  showPopover(e) {
    if (e) e.preventDefault();

    this.setState({
      popoverOpen: true,
    });
  },

  hidePopover() {
    this.setState({
      popoverOpen: false,
    });
  },

  getChildContext() {
    const {
      loggedIn,
      zipCode,
      popoverOpen,
      searching,
      locations: { selected: selectedLocation },
    } = this.state;

    const {
      urls,
      uploaded_to_album: uploadedToAlbum,
      uploaded_to_album_path: uploadedToAlbumPath,
      features: {
        checkout_without_login: checkoutWithoutLogin,
        projects_must_be_finished: projectsMustBeFinished,
        delivery_method_scope_order: deliveryMethodScopeOrder,
        disable_store_name: disableStoreName,
        taxes_and_delivery_prompt: taxesAndDeliveryPrompt,
        allow_account_signup_in_checkout: allowAccountSignupInCheckout,
      },
    } = this.props;

    return {
      loggedIn,
      zipCode,
      popoverOpen,
      showPopover: this.showPopover,
      hidePopover: this.hidePopover,
      searching,
      userDetails: {},
      selectedLocation,
      urls: {
        collectionPointLocator: urls.collection_point_locator_page,
      },
      unavailableItems: this.unavailableItems(),
      uploadedToAlbum,
      uploadedToAlbumPath,
      projectsMustBeFinished,
      disableStoreName,
      taxesAndDeliveryPrompt,
      showDeliveryOptionSelectorsWithinItems: !deliveryMethodScopeOrder,
      checkout: {
        url: this.props.urls.checkout,
        withoutLogin: checkoutWithoutLogin,
        allowAccountSignupInCheckout: allowAccountSignupInCheckout,
      },
    };
  },

  render() {
    const { prints, prismItems } = this.state;

    return OrderCalculator.somePrints(prints) ||
      OrderCalculator.somePrismItems(prismItems) ? (
      this.renderHaveItemsInCart()
    ) : (
      <EmptyCart>
        <Totalizer
          onRef={(ref) => (this.totalizer = ref)}
          price={0}
          quantity={0}
          shippingCost={0}
        />
      </EmptyCart>
    );
  },

  unavailableItems() {
    const {
      prismItems,
      locations: { pickup },
    } = this.state;
    const alivePrismItems = OrderCalculator.alivePrismItems(prismItems);

    return unavailableOrderItems(alivePrismItems, pickup);
  },

  renderDeliveryOptionsForm() {
    const deliveryOptions = this.availableDeliveryOptions();
    const selectedDeliveryOption = this.firstSelectedDeliveryOption();

    return (
      <div
        data-test-id="mobile-delivery-options-form"
        className="d-md-none mb-1">
        <DeliveryOptionsForm
          hideIcon
          options={deliveryOptions}
          selectedOption={selectedDeliveryOption}
        />
      </div>
    );
  },

  renderHaveItemsInCart() {
    const { prints, prismItems, displayWalmartBusinessLoginOrgMessage } =
      this.state;
    const {
      features,
      buying_restrictions,
      uploaded_to_album_path: uploadedToAlbumPath,
    } = this.props;
    const deliveryOptions =
      features?.delivery_method_scope_order && this.availableDeliveryOptions();
    const promotionMessageKey = getPromotionMessageKey({ features, prints });

    return (
      <div>
        <div className="row mx-md-0">
          <article className="col-md-8 col-lg-9">
            <DeliveryOptionAdjustments
              prints={prints}
              prismItems={prismItems}
              adjustments={this.props.delivery_option_adjustments}
            />
            <h4>
              <b>Your photo {translate('cart')}:</b>
              <span className="photo-cart-quantity">
                <Pluralizer
                  count={OrderCalculator.totalQuantity({ prints, prismItems })}
                  singular="item"
                />
              </span>
            </h4>
            {displayWalmartBusinessLoginOrgMessage && (
              <IncompleteWmbAccountMessage
                handleWalmartBusinessOrgLoginMessage={
                  this.handleWalmartBusinessOrgLoginMessage
                }
                loginOrgUrl={buying_restrictions?.login_org_url}
              />
            )}
            <div className="d-md-none">
              {promotionMessageKey && (
                <WalmartPlusPromotion
                  promotionMessageKey={promotionMessageKey}
                  fullMessage
                />
              )}
              <TaxesAndDeliveryPrompt
                us="Check out to see shipping, taxes & fees"
                row="Please check out to see delivery costs"
              />
            </div>
            {uploadedToAlbumPath && (
              <>
                <hr className="d-md-none" />
                <AlbumsMessage
                  uploadedToAlbumPath={uploadedToAlbumPath}
                  className="d-md-none"
                />
              </>
            )}
            {deliveryOptions && this.renderDeliveryOptionsForm()}
            {this.renderItemGroups()}
          </article>
          <aside className="col-md-4 col-lg-3 px-0">
            <Totalizer
              onRef={(ref) => (this.totalizer = ref)}
              freeShippingEnabled={features?.free_shipping_enabled}
              freeShippingAssetUrl={this.props?.free_shipping_asset_url}
              freeShippingThreshold={this.props?.free_shipping_threshold}
              price={OrderCalculator.subtotalPrice({ prints, prismItems })}
              quantity={OrderCalculator.totalQuantity({ prints, prismItems })}
              homeDeliveryItemsPrice={OrderCalculator.homeDeliveryItemsPrice({
                prints,
                prismItems,
              })}
              shippingCost={OrderCalculator.shippingCost({
                prints,
                prismItems,
              })}
              checkoutBlocker={this.getCheckoutBlocker()}
              deliveryOptions={deliveryOptions}
              selectedDeliveryOptions={this.selectedDeliveryOptions()}
              crossSellItemCheckOutClick={this.handleShowCrossSellItemReminder}
              promotionMessageKey={promotionMessageKey}
            />
          </aside>
        </div>
        {this.renderLimitModal()}
        {this.renderCrossSellItemReminder()}
        {this.isDeliveryMethodScopeOrder() && (
          <DisperateDeliveryOptionsModal
            options={this.availableDeliveryOptions()}
            selectedOption={this.firstSelectedDeliveryOption()}
            open={this.state.disperateDeliveryOptionsModalIsOpen}
            onClose={this.handleDisperateDeliveryOptionsModalClose}
            onSelect={this.handleDisperateDeliveryOptionSelect}
          />
        )}
      </div>
    );
  },

  renderItemGroups() {
    const $nodes = [];
    const { prints } = this.state;

    for (const [
      deliveryType,
      { group: option, items },
    ] of OrderContents.groupedByDeliveryOptionType(this.state)) {
      const locations =
        (({ pickup, collection }) => {
          switch (deliveryType) {
            case 'PICKUP':
              return pickup;
            case 'COLLECT':
              return collection;
          }
        })(this.state.locations) || [];
      const prismItems = [...items].filter((item) => item !== prints);

      $nodes.push(
        <Card className="shadow-sm mb-3" key={`deliveryType-${deliveryType}`}>
          <Card.Header className="grey-zone">
            <DeliveryOptionsGroupHeader
              option={option || {}}
              locations={locations}
              errorMessage={this.state.storeFinderErrorMessage}
            />
          </Card.Header>
          <Card.Body>
            {items.has(prints) ? (
              <Prints
                {...prints}
                key={`prints-${deliveryType}`}
                updating={this.state.updating.all || this.state.updating.prints}
                alternatePickupStore={this.state.alternatePickupStore}
              />
            ) : null}
            {prismItems.length ? (
              <Prism
                key={`prism-${deliveryType}`}
                items={prismItems}
                updating={this.state.updating}
                outOfStock={this.props.out_of_stock_errors}
                alternatePickupStore={this.state.alternatePickupStore}
              />
            ) : null}
          </Card.Body>
        </Card>,
      );
    }

    return $nodes;
  },

  renderLimitModal() {
    return (
      <Modal
        title="Item limit reached"
        className="cart-checkout-limit-modal"
        open={this.state.itemsLimitModelIsOpen}
        close
        maxWidth={486}
        actions={
          <div>
            <button
              className="btn btn-link"
              onClick={this.handleItemsLimitModalClose}>
              Close
            </button>
          </div>
        }
        onClose={this.handleItemsLimitModalClose}>
        <p>
          Sorry, you have exceeded the maximum of{' '}
          <Pluralizer count={this.props.items_limit} singular="item" /> in your
          cart. Please remove{' '}
          <Pluralizer count={this.itemsLimitExcess()} singular="item" /> from
          your cart before checkout.
        </p>
      </Modal>
    );
  },

  renderCrossSellItemReminder() {
    const unEditedItems = this.state.prismItems
      .filter((prismItem) => prismItem.cross_sell_item)
      .map((prismItem, i) => {
        return (
          <div className="my-2" key={i}>
            <span className="mr-2">{prismItem.product_title}</span>
            <a href={prismItem.edit_url}>Edit</a>
          </div>
        );
      });

    return (
      <Modal
        title={
          <>
            <i className="fas fa-exclamation-circle" /> {translate('Cart')}{' '}
            Updated
          </>
        }
        className="cart-checkout-cross-sell-reminder-modal mx-2 mx-lg-0 mx-md-0"
        open={this.state.crossSellItemReminderShow}
        close
        maxWidth={486}
        actions={
          <div>
            <button
              className="btn btn-link"
              onClick={this.handleCloseCrossSellItemReminder}>
              Close
            </button>
          </div>
        }
        onClose={this.handleCloseCrossSellItemReminder}>
        <span>
          You added an item! Please remember to {translate('personalise')} this
          item before checkout:
          {unEditedItems}
        </span>
      </Modal>
    );
  },
  loadData(callback, url = this.props.urls.order) {
    fetch(`${url}?_=${Date.now()}`, {
      credentials: 'same-origin',
    })
      .then((response) => response.json())
      .then((data) => callback(data))
      .catch(() => {});
  },

  findPickupLocations() {
    if (!this.state.zipCode) {
      this.setState({
        searching: false,
      });
      return;
    }

    this.setState({
      locations: {
        ...this.state.locations,
        pickup: [],
      },
      storeFinderErrorMessage: undefined,
      searching: true,
    });

    const serviceFilter = (() => {
      switch (this.soonestSelectedDeliveryTime()) {
        case DeliveryCalculator.ONE_HOUR:
          return 'SERVICE_PHOTO_CENTER_ONE_HOUR';
        case DeliveryCalculator.TWENTY_FOUR_HOURS:
          return 'SERVICE_PHOTO_CENTER_SAME_DAY_PICKUP';
      }
    })();

    genericHelpers
      .findLocations(
        this.props.urls.store_locator,
        this.state.zipCode,
        serviceFilter,
      )
      .then((locations) => {
        const alternatePickupStore =
          pickupStoreWithEverythingInStock(locations);

        this.setState(
          {
            locations: { ...this.state.locations, pickup: locations },
            alternatePickupStore: alternatePickupStore,
            searching: false,
          },
          function () {
            let selectedLocationId = this.state.locations.selected;

            if (typeof window !== 'undefined' && window.localStorage) {
              const lsStoreId = window.localStorage.getItem('storeId');
              if (
                lsStoreId &&
                locations.some((l) => String(l.id) === String(lsStoreId))
              ) {
                selectedLocationId = lsStoreId;
              }
            }

            const isSelectedIdInList =
              selectedLocationId &&
              locations.some(
                (location) =>
                  String(location.id) === String(selectedLocationId),
              );

            if (!isSelectedIdInList) {
              const newSelectedLocationId = get(locations[0], 'id');
              if (newSelectedLocationId) {
                this.handleSelectedLocationChange(newSelectedLocationId);
              }
            } else if (
              String(this.state.locations.selected) !==
              String(selectedLocationId)
            ) {
              this.handleSelectedLocationChange(selectedLocationId);
            }

            LocationCookies.setNearestStores(locations);
            this.setUpdating('location', false);
          },
        );
      })
      .catch((errorMessage) => {
        this.setState({
          storeFinderErrorMessage: errorMessage,
          searching: false,
          locations: {
            ...this.state.locations,
            selected: undefined,
          },
          alternatePickupStore: null,
        });
        this.setUpdating('location', false);
      });
  },

  findCollectionLocations() {
    fetch(
      `${this.props.urls.collection_point_locator}?q=${this.state.zipCode}`,
      {
        credentials: 'same-origin',
      },
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          locations: {
            ...this.state.locations,
            collection: data.data,
          },
        });
        this.setUpdating('location', false);
      })
      .catch(() => {
        this.setUpdating('location', false);
        return {};
      });
  },

  soonestSelectedDeliveryTime() {
    const allSelectedDeliveryOptionHours = this.selectedDeliveryOptions().map(
      (opt) => opt.time_hours,
    );

    return Math.min.apply(null, allSelectedDeliveryOptionHours);
  },

  handleLoggedIn() {
    this.setState({
      loggedIn: true,
    });
  },

  handleCartMerged(basketPath) {
    location = basketPath;
  },

  handlePrintsDeleteSize(size) {
    const { prints } = this.state;

    const sizeToDelete = prints.sizes.find((printSize) => printSize === size);

    if (!sizeToDelete) {
      return;
    }

    sizeToDelete.deleted = Date.now();

    this.setState(
      {
        prints: { ...prints },
      },
      () => {
        deleteOnServer({
          url: this.props.urls.prints_remove,
          redirect: this.props.urls.shopping_cart,
          size: size.size,
          finish: size.print_finish_key,
          soft: true,
        }).then(this.fetchNewOrderTimestamps);

        this.notifyCartItemsChanged();
      },
    );

    this.notifyCartItemsChanged(
      CartItemsChangeEvents.REMOVED_PRINTS,
      null,
      null,
      sizeToDelete,
    );
  },
  handlePrintsDeleteAll(finish = 'all') {
    const { prints } = this.state;
    const deletedFinishes =
      finish === 'all'
        ? [...new Set(prints.sizes.map((size) => size.print_finish_key))]
        : [finish];

    this.setState(
      {
        prints: {
          ...prints,
          deletedFinishes: [...prints.deletedFinishes, ...deletedFinishes],
        },
      },
      async () => {
        await Promise.all(
          deletedFinishes.map(
            async (finish) =>
              await deleteOnServer({
                url: this.props.urls.prints_remove,
                redirect: this.props.urls.shopping_cart,
                finish,
                soft: true,
              }),
          ),
        );
        this.fetchNewOrderTimestamps();
        this.notifyCartItemsChanged();
      },
    );

    this.notifyCartItemsChanged(CartItemsChangeEvents.REMOVED_PRINTS);
  },
  handlePrintsUndeleteAll(finish) {
    const { prints } = this.state;

    this.setState(
      {
        prints: {
          ...prints,
          deletedFinishes: [...prints.deletedFinishes].filter(
            (deletedFinish) => deletedFinish !== finish,
          ),
        },
      },
      () => {
        updateOnServer({
          url: this.props.urls.prints_unremove,
          redirect: this.props.urls.shopping_cart,
          finish,
        }).then(this.fetchNewOrderTimestamps);
        this.notifyCartItemsChanged();
      },
    );

    this.notifyCartItemsChanged(CartItemsChangeEvents.UNREMOVED_PRINTS);
  },
  handlePrintsUndeleteSize({ print_finish_key: finish, size }) {
    const { prints } = this.state;

    let sizeUnDeleted;
    prints.sizes.forEach((printSize) => {
      if (printSize.size === size && printSize.print_finish_key === finish) {
        sizeUnDeleted || (sizeUnDeleted = printSize);
        delete printSize.deleted;
      }
    });

    this.setState(
      {
        prints: { ...prints },
      },
      () => {
        updateOnServer({
          url: this.props.urls.prints_unremove,
          redirect: this.props.urls.shopping_cart,
          finish,
          size,
        }).then(this.fetchNewOrderTimestamps);
        this.notifyCartItemsChanged();
      },
    );

    this.notifyCartItemsChanged(
      CartItemsChangeEvents.UNREMOVED_PRINTS,
      null,
      null,
      sizeUnDeleted,
    );
  },

  handlePrismItemQuantityChange(item, quantity) {
    updateOnServer({
      url: this.props.urls.prism_update,
      redirect: this.props.urls.shopping_cart,
      item: item.id,
      quantity,
    }).then((data) => {
      this.loadData((data) => {
        // overwrite just the changed item's quantity and cost
        const { prismItems: originalItems } = this.state,
          originalItem = originalItems.find((_item) => _item.id === item.id),
          newItem = data.prism_items.find((_item) => _item.id === item.id);

        originalItem.cost = newItem.cost;
        originalItem.quantity = newItem.quantity;

        this.setState(
          {
            prismItems: [...originalItems],
          },
          function () {
            this.setUpdating(item.id, false);
            this.notifyCartItemsChanged();
          },
        );
      });
    });

    this.setUpdating(item.id);

    this.notifyCartItemsChanged(
      CartItemsChangeEvents.QUANTITY_CHANGED,
      item.id,
      quantity,
    );
  },
  handlePrismItemDelete(item, soft = this.state.loggedIn) {
    const { prismItems } = this.state;

    prismItems.forEach((prismItem) => {
      if (prismItem.id == item.id) {
        prismItem.deleted = soft
          ? DeletionFirmness.SOFT
          : DeletionFirmness.HARD;
      }
    });

    return new Promise((resolve) => {
      this.setState(
        {
          prismItems: [...prismItems],
        },
        async function () {
          await deleteOnServer({
            url: this.props.urls.prism_remove,
            redirect: this.props.urls.shopping_cart,
            prism_id: item.id,
            soft,
          });

          this.fetchNewOrderTimestamps();
          this.notifyCartItemsChanged();

          resolve();
        },
      );

      this.notifyCartItemsChanged(CartItemsChangeEvents.REMOVED_PRISM, item.id);
    });
  },
  handlePrismItemUndelete(item) {
    const { prismItems } = this.state;

    prismItems.forEach((prismItem) => {
      if (prismItem.id === item.id) delete prismItem.deleted;
    });

    this.setState(
      {
        prismItems: [...prismItems],
      },
      () => {
        updateOnServer({
          url: this.props.urls.prism_unremove,
          redirect: this.props.urls.shopping_cart,
          prism_id: item.prism_id,
        }).then(this.fetchNewOrderTimestamps);

        this.notifyCartItemsChanged();
      },
    );

    this.notifyCartItemsChanged(CartItemsChangeEvents.UNREMOVED_PRISM, item.id);
  },

  handleDeliveryOptionChange(itemId, optionId) {
    const {
      order: { default_pickup_location: defaultPickupLocation },
    } = this.props;
    this.setUpdating(itemId);

    return new Promise((resolve) => {
      updateOnServer({
        url: this.props.urls.update_delivery_option,
        item: itemId || 'prints',
        option: optionId,
        redirect: this.props.urls.shopping_cart,
      }).then((responseData) => {
        if (responseData?.status === 'error') {
          alert(responseData.message || 'Unable to update delivery option.');
          this.setUpdating(itemId, false);
          resolve();
          return;
        }
        const swappedIds = new Set(responseData?.swapped_item_ids || []);
        this.loadData((data) => {
          this.setState(
            (prevState) => {
              const swapTs = Date.now();
              const prismItems = data.prism_items.map((item) => {
                if (!swappedIds.has(item.id)) return item;
                // WebPrism briefly sets state to "copy:<uuid>" while it processes the
                // transform job (~1s). loadData races against that window and can return
                // copy_in_progress: true, showing a false-positive warning. We suppress
                // it here because the swap was intentional and WP resolves in <1s.
                const thumb = item.thumbnail || '';
                const sep = thumb.includes('?') ? '&' : '?';
                return {
                  ...item,
                  wasSwapped: true,
                  copy_in_progress: false,
                  thumbnail: `${thumb}${sep}v=${swapTs}`,
                };
              });
              return {
                prints: { ...prevState.prints, ...data.prints_summary },
                prismItems,
                popoverOpen: false,
              };
            },
            () => {
              // update stores/collection locations
              this.fetchNewStoreLocations();
              this.setUpdating(itemId, false);
              this.notifyCartItemsChanged({
                type: CartItemsChangeEvents.UPDATED,
              });
              this.updateStoreSelection(this.state.locations.selected);
              if (!this.state.zipCode && !this.hasPickupDeliveryOptionType()) {
                this.showPopover();
              }
              if (
                !this.state.zipCode &&
                this.hasPickupDeliveryOptionType() &&
                defaultPickupLocation
              ) {
                this.updateDefaultStoreSelection(defaultPickupLocation);
              }

              resolve();
            },
          );
        });
      });
    });
  },

  updateStoreSelection(locationId) {
    this.setState({
      locations: {
        ...this.state.locations,
        selected: this.hasPickupDeliveryOptionType() ? locationId : undefined,
      },
    });
  },

  updateDefaultStoreSelection(location) {
    this.setState((prev) => ({
      locations: {
        ...prev.locations,
        pickup: [location],
        selected: location.id,
      },
    }));

    updateOnServer({
      url: this.props.urls.update_delivery_pickup,
      redirect: this.props.urls.shopping_cart,
      option: location.id,
    });
  },

  handleSelectedLocationChange(locationId) {
    this.updateStoreSelection(locationId);

    if (typeof window !== 'undefined' && window.localStorage && locationId) {
      window.localStorage.setItem('storeId', locationId);
    }

    updateOnServer({
      url: this.props.urls.update_delivery_pickup,
      redirect: this.props.urls.shopping_cart,
      option: locationId,
    });
  },

  handleZipCodeChange(zipCode) {
    if (!isPostalCodeLocal(zipCode)) return;

    this.setState(
      {
        zipCode,
      },
      function () {
        this.hidePopover();
        // if PICKUP or COLLECT is selected anywhere
        // find stores near to this
        const selectedDeliveryOptions = this.selectedDeliveryOptions();

        if (
          selectedDeliveryOptions.some((opt) =>
            PICKUP_DELIVERY_OPTION_TYPES.includes(opt.type),
          )
        ) {
          this.setUpdating('location');

          this.fetchNewStoreLocations();
        }
      },
    );

    if (isPostalCodeLocal(zipCode)) {
      // Set location cookies for Walmart
      LocationCookies.setDeliveryLocation(
        this.props.urls.zipcode_to_location,
        zipCode,
      );
      // store for future use
      ZipCodes.save(zipCode);
      ZipCodes.persist(this.props.urls.update_user_postcode, zipCode);
    }

    builderDispatch.delayedDispatch({
      type: CartItemsChangeEvents.ZIP_CODE_CHANGED,
      value: zipCode,
    });
  },

  fetchNewStoreLocations() {
    uniqBy(this.selectedDeliveryOptions(), 'type').forEach((deliveryOption) => {
      switch (deliveryOption.type) {
        case 'PICKUP':
          this.setUpdating('location');
          this.findPickupLocations();
          break;
        case 'COLLECT':
          this.setUpdating('location');
          this.findCollectionLocations();
          break;
      }
    });
  },
  fetchNewOrderTimestamps() {
    if (orderTimestampsPresent(this.state.locations)) {
      this.fetchNewStoreLocations();
    }
  },
  selectedDeliveryOptions() {
    return OrderContents.selectedDeliveryOptions(this.state);
  },

  firstSelectedDeliveryOption() {
    return get(this.selectedDeliveryOptions(), [0, 'key']);
  },

  availableDeliveryOptions() {
    return OrderContents.availableDeliveryOptions(this.state);
  },

  hasPickupDeliveryOptionType() {
    return OrderContents.hasDeliveryOptionType(
      this.state,
      PICKUP_DELIVERY_OPTION_TYPES,
    );
  },

  hasUnavailableItemForPickup() {
    const {
      locations: { selected },
    } = this.state;

    return this.unavailableItems().some((item) => item.storeId === selected);
  },

  getCheckoutBlocker() {
    const {
      prints,
      prismItems,
      locations: { selected },
      updating,
      displayWalmartBusinessLoginOrgMessage,
    } = this.state;

    if (Object.values(updating).some(Boolean)) {
      return checkoutBlockers.cartUpdating;
    }

    if (this.itemsLimitExceeded()) {
      return checkoutBlockers.itemsLimitExceeded;
    }

    if (displayWalmartBusinessLoginOrgMessage) {
      return checkoutBlockers.wmbAccountRestricted;
    }

    const alivePrints = OrderCalculator.alivePrints(prints);
    const alivePrismItems = OrderCalculator.alivePrismItems(prismItems);

    // test for missing_attributes, disabled_options_chosen, or disabled
    for (const prismItem of alivePrismItems) {
      if (prismItem.missing_attributes) {
        return checkoutBlockers.missingAttributes;
      }

      if (prismItem.disabled_options_chosen) {
        return checkoutBlockers.disabledOptionsChosen;
      }

      if (prismItem.disabled) {
        return checkoutBlockers.disabled;
      }

      if (prismItem.disabled_theme) {
        return checkoutBlockers.disabledTheme;
      }

      if (prismItem.cross_sell_item) {
        return checkoutBlockers.crossSellItem;
      }

      // Blocking A/B variant: transformed items must be reviewed in the builder before checkout.
      // Advisory items never carry needs_review, so they are never blocked here.
      if (prismItem.needs_review) {
        return checkoutBlockers.transformsNeedReview;
      }
    }

    const items = [].concat(alivePrints, alivePrismItems).filter(Boolean);
    // test for delivery option not set
    if (items.some((item) => !OrderContents.selectedDeliveryOption(item))) {
      return checkoutBlockers.deliveryOptionNotSet;
    }

    const hasPickupDeliveryOptionType = this.hasPickupDeliveryOptionType();
    const hasUnavailableItem = this.hasUnavailableItemForPickup();

    if (hasPickupDeliveryOptionType && hasUnavailableItem) {
      return checkoutBlockers.unavailableItem;
    }

    if (this.props.features.pickup_only_pay_offline) {
      const hasDeliveryOptionTypeOtherThanPickup =
        OrderContents.hasDeliveryOptionTypeOtherThan(
          { prints: alivePrints, prismItems: alivePrismItems },
          PICKUP_DELIVERY_OPTION_TYPES,
        );

      // if pickup_only_pay_offline is set and there are any items set to PICKUP or COLLECT as well as alternative delivery types
      if (hasPickupDeliveryOptionType && hasDeliveryOptionTypeOtherThanPickup) {
        return checkoutBlockers.incompatibleDeliveryTypes;
      }
    }

    // if there are any items set to PICKUP or COLLECT but there's no store selected
    if (!selected && hasPickupDeliveryOptionType) {
      return checkoutBlockers.noPickupLocation;
    }

    return checkoutBlockers.none;
  },

  setUpdating(key = 'prints', value = true) {
    if (this.isDeliveryMethodScopeOrder()) {
      key = 'all';
    }

    this.setState({
      updating: {
        ...this.state.updating,
        [key]: value,
      },
    });
  },

  handleItemsLimitModalClose() {
    this.setState({ itemsLimitModelIsOpen: false });
  },
  handleShowCrossSellItemReminder() {
    this.setState({ crossSellItemReminderShow: true });
  },
  handleCloseCrossSellItemReminder() {
    this.setState({ crossSellItemReminderShow: false });
  },
  itemsLimitExceeded() {
    if (this.props.items_limit == 0) {
      return false;
    }
    return OrderCalculator.lineItemCount(this.state) > this.props.items_limit;
  },
  itemsLimitExcess() {
    return OrderCalculator.lineItemCount(this.state) - this.props.items_limit;
  },
  isDeliveryMethodScopeOrder() {
    return get(this.props.features, 'delivery_method_scope_order', false);
  },
  async handleDisperateDeliveryOptionSelect(optionId) {
    this.handleDisperateDeliveryOptionsModalClose();

    await this.handleDeliveryOptionChange(null, optionId);

    const unknownGroup =
      OrderContents.groupedByDeliveryOptionType(this.state).get('-UNKNOWN-') ||
      {};
    const iter = unknownGroup.items.values();
    let value = iter.next();

    while (!value.done) {
      const item = value.value;

      (await item.prism_id)
        ? this.handlePrismItemDelete(item)
        : this.handlePrintsDeleteAll();

      value = iter.next();
    }
  },
  handleDisperateDeliveryOptionsModalClose() {
    this.setState({ disperateDeliveryOptionsModalIsOpen: false });
  },
  notifyCartItemsChanged(
    type = CartItemsChangeEvents.UPDATED,
    prism_item_id,
    quantity,
    print_size,
  ) {
    builderDispatch.delayedDispatch({
      type,
      items: {
        prints: { ...this.state.prints },
        prism: this.state.prismItems.map((prismItem) => ({ ...prismItem })),
      },
      prism_id: prism_item_id,
      quantity,
      print_size,
    });
  },
  handleWalmartBusinessOrgLoginMessage(showMessage) {
    this.setState({
      displayWalmartBusinessLoginOrgMessage: showMessage,
    });
  },
});

Cart.childContextTypes = {
  loggedIn: PropTypes.bool,
  zipCode: PropTypes.string,
  popoverOpen: PropTypes.bool,
  showPopover: PropTypes.func,
  hidePopover: PropTypes.func,
  searching: PropTypes.bool,
  userDetails: PropTypes.shape({
    addressStreet: PropTypes.string,
    addressAdditional: PropTypes.string,
    addressCity: PropTypes.string,
  }),
  selectedLocation: PropTypes.string,
  urls: PropTypes.shape({
    collectionPointLocator: PropTypes.string,
  }),
  unavailableItems: PropTypes.array,
  uploadedToAlbum: PropTypes.string,
  uploadedToAlbumPath: PropTypes.string,
  projectsMustBeFinished: PropTypes.bool,
  showDeliveryOptionSelectorsWithinItems: PropTypes.bool,
  disableStoreName: PropTypes.bool,
  taxesAndDeliveryPrompt: PropTypes.string,
  checkout: PropTypes.shape({
    withoutLogin: PropTypes.bool,
    available: PropTypes.bool,
    url: PropTypes.string,
    allowAccountSignupInCheckout: PropTypes.bool,
  }),
};

// export default Cart;
export default Cart;
